import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { grey } from "@mui/material/colors";
import { useNavigate } from "react-router-dom";
import { ProtectedPaths } from "routes";
import dayjs from "dayjs";
import { ProductionForecastGroup } from "api/models/ProductionForecast";

interface HeaderProps {
  forecastGroup: ProductionForecastGroup;
}

const Header: React.FC<HeaderProps> = ({ forecastGroup }) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 4,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <IconButton sx={{ mr: "1rem" }} onClick={() => navigate(-1)}>
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h5" component="h5">
          Production forecast
          {forecastGroup && (
            <span style={{ color: grey[500] }}>
              {` - ${dayjs(forecastGroup.forecastDate).format(
                "DD.MM.YYYY",
              )} - ${dayjs(forecastGroup.forecastDate).format("dddd")}`}
            </span>
          )}
        </Typography>
      </Box>
    </Box>
  );
};

export default Header;
